import { CropYear } from "../../cropYear"
import { FieldViewModel } from "../../fields"
import { Years } from "./types"
import { DomItem } from "./domItem"
import { getHistoryProvider } from "./history"
import { createTimelineItems3 } from "./layout3"
import { canSelectItem, isItemFiltered } from "./selection"
import { ITimelineCtrl, SelectionContext, TimelineViewModel, ViewConfig } from "./types"
import { createGlobalViewModel } from "./vm"
import * as state from "./viewState"

export interface TimelineState {
    vm: TimelineViewModel
    controller: ITimelineCtrl
    viewState: TimelineViewState
}

export interface TimelineViewState {

    scroll: {
        scrollLeft: number
        scrollTop: number
    }

    dragging: boolean,

    currentItem: DomItem

}

export function getInitialState(
    selection: SelectionContext,
    fields: FieldViewModel[],
    year: CropYear,
    years: Years,
    viewConfig: ViewConfig,
    showIds: boolean): TimelineState {


    const history = getHistoryProvider(years, fields)

    const viewState = {
        scroll: state.viewState.scroll,
        dragging: false,
        currentItem: null as DomItem
    }

    const controller: ITimelineCtrl = {

        selection: selection ?? {
            multiple: false,
            field: undefined,
            cropping: [],
            canSelectAsEditTarget: _ => false,
            selectCropping: _ => { },
        },

        viewConfig,

        get isDragging() {
            return viewState.dragging
        },

        isEditing: () => false,

        popupContext: null,

        items: null,

        render: () => { },

        isItemFiltered: i => isItemFiltered(controller, i),
        canSelectItem: i => canSelectItem(controller, i),

        setZoomLevelWheel: s => { },

        setCurrentCropping: c => { }

    }

    const vm = {
        ...createGlobalViewModel(controller, fields, history, year, years, createTimelineItems3),
        showIds
    }

    controller.items = vm.allitems

    return {
        viewState,
        controller,
        vm
    }

}
